import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import debug from 'debug';
import { createRoot } from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { App } from '@/components/App/App';
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';
import { IframeEventType, WebClientEventType } from '@/ts';
import { SafeRecoilDevTools } from '@/util/recoil-redux';
import { onDocumentReady, parseEvent } from '@/util/utils';
import 'keen-slider/keen-slider.min.css';
import './i18n';
let log;
let widgetId;
let initialized = false;
/**
 * Handle events from the web-client
 */
function handleEventFromParent(messageEvent) {
    if (initialized) {
        return;
    }
    const event = parseEvent(widgetId, messageEvent);
    if (!event) {
        return;
    }
    log(`Event from web-client: ${event.type}`, event);
    if (event.type === WebClientEventType.SetConfig) {
        const app = (_jsx(ErrorBoundary, { children: _jsxs(RecoilRoot, { children: [_jsx(SafeRecoilDevTools, {}), _jsx(App, { userConfig: event.data })] }) }));
        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = createRoot(container);
        root.render(app);
        log('Rendered <App />');
        initialized = true;
    }
}
/**
 * Initializes the iframe and load the event handler
 *
 */
export const init = async (_widgetId) => {
    widgetId = _widgetId;
    log = debug(`moveo:iframe:${widgetId}:controller`);
    await onDocumentReady();
    window.addEventListener('message', handleEventFromParent);
    // Announce that the iframe was loaded so that it gets the userConfig
    if (window.parent) {
        window.parent.postMessage({ type: `${widgetId}${IframeEventType.IframeLoaded}` }, '*');
    }
};
